@if (!isEmpty(get(internalLinksRow, 'internal_links.internal_link_reference', []))) {
  <section [class.gray-bg]="get(internalLinksRow, 'internal_links.gray_background', '')">
    <div class="internal-links">
      <div class="category-top-title fx-row fx-row-h-center pb-2">
        @if (internalLinksRow.internal_links?.title) {
          <h2 class="col-md-7 text-center">
            {{ internalLinksRow.internal_links?.title }}
          </h2>
        }
      </div>
      <div
        class="links container-gridless d-flex flex-row justify-content-center flex-wrap"
        >
        @for (link of internalLinksRow.internal_links?.internal_link_reference; track link.uid ?? link.url) {
          <div
            class="internal-link d-flex col-12 col-md-3 col-sm-6 text-center"
            >
            @if (link?.url) {
              <a class="internal-link-1" [routerLink]="getLinkUrl(link?.url)">
                @if (link?.internal_links_partial?.image?.internal_links_image_url) {
                  <img [src]="getWebpImg(link?.internal_links_partial?.image?.internal_links_image_url)" [alt]="link?.internal_links_partial?.image?.image_title" />
                }
                @if (link?.internal_links_partial?.internal_links_header) {
                  <h4 class="old my-1 px-2">{{ link?.internal_links_partial?.internal_links_header }}</h4>
                }
                <span class="link-blue"> Explore <mat-icon>chevron_right</mat-icon> </span>
              </a>
            }
          </div>
        }
      </div>
    </div>
  </section>
}
@if (get(internalLinksRow, 'internal_links.split_line', '')) {
  <hr class="m-0" />
}
